document.addEventListener('DOMContentLoaded', function () {

  // custom loupe cursor (desktop only, respects reduced motion)
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = window.matchMedia('(min-width:900px)').matches;

  if (isDesktop && !prefersReduced) {
    document.body.classList.add('has-loupe');
    var loupe = document.createElement('div');
    loupe.className = 'loupe';
    document.body.appendChild(loupe);

    window.addEventListener('mousemove', function (e) {
      loupe.style.left = e.clientX + 'px';
      loupe.style.top = e.clientY + 'px';
    });

    document.querySelectorAll('[data-tilt]').forEach(function (card) {
      card.addEventListener('mouseenter', function () { loupe.classList.add('expand'); });
      card.addEventListener('mouseleave', function () { loupe.classList.remove('expand'); });
    });
  }

  // product image tilt on hover
  document.querySelectorAll('[data-tilt]').forEach(function (card) {
    var obj = card.querySelector('[data-tilt-obj]');
    if (!obj) return;
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      obj.style.transform = 'rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 14) + 'deg)';
    });
    card.addEventListener('mouseleave', function () {
      obj.style.transform = 'rotateY(0) rotateX(0)';
    });
  });

  // seal / vault-door transitions between sections
  var seals = document.querySelectorAll('.seal');
  if ('IntersectionObserver' in window && seals.length && !prefersReduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var l = entry.target.querySelector('.leaf.l');
        var r = entry.target.querySelector('.leaf.r');
        if (!l || !r) return;
        l.style.transform = 'translateX(-6%)';
        r.style.transform = 'translateX(6%)';
        setTimeout(function () {
          l.style.transform = 'translateX(0)';
          r.style.transform = 'translateX(0)';
        }, 550);
      });
    }, { threshold: 0.6 });
    seals.forEach(function (s) { io.observe(s); });
  }

  // cart quantity stepper (cart page)
  document.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var v = Math.max(0, parseInt(input.value || '1', 10) - 1);
      input.value = v;
    });
  });
  document.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var v = parseInt(input.value || '1', 10) + 1;
      input.value = v;
    });
  });

  // pdp thumbnail swap (basic, no variant media matching)
  document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = document.querySelector('[data-pdp-main-image]');
      if (full && thumb.dataset.fullSrc) {
        full.src = thumb.dataset.fullSrc;
      }
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // collection grid: variant swatches update image/price in place, link goes to that variant
  document.querySelectorAll('[data-product-card]').forEach(function (card) {
    var swatches = card.querySelectorAll('[data-variant-swatch]');
    var img = card.querySelector('[data-variant-image]');
    var priceEl = card.querySelector('[data-variant-price]');
    var titleLink = card.querySelector('h3 a');
    var variantIdInput = card.querySelector('[data-variant-id-input]');
    var addBtn = card.querySelector('[data-add-to-cart-btn]');
    var bigPreview = document.getElementById('collectionPreviewImage');

    function setBigImage(url) {
      if (bigPreview && url) bigPreview.src = url;
    }

    // clicking the thumbnail also pushes that product's current image into the big preview
    var thumb = card.querySelector('[data-variant-image]');
    if (thumb && thumb.closest('a')) {
      thumb.closest('a').addEventListener('click', function (e) {
        e.preventDefault();
        setBigImage(thumb.dataset.bigImage);
      });
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');
        if (img && swatch.dataset.image) img.src = swatch.dataset.image;
        if (priceEl && swatch.dataset.price) priceEl.textContent = swatch.dataset.price;
        if (titleLink && swatch.dataset.url) titleLink.setAttribute('href', swatch.dataset.url);
        if (variantIdInput && swatch.dataset.variantId) variantIdInput.value = swatch.dataset.variantId;
        if (addBtn) {
          var soldOut = swatch.dataset.soldOut === 'true';
          addBtn.disabled = soldOut;
          addBtn.textContent = soldOut ? 'Sold out' : 'Add to cart';
          addBtn.classList.remove('added');
        }
        setBigImage(swatch.dataset.bigImage);
      });
    });
  });

  // add to cart via AJAX (progressive enhancement over the plain form)
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart-btn]');
      if (!btn || btn.disabled) return;

      var formData = new FormData(form);
      var originalText = 'Add to cart';

      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          btn.classList.add('added');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var cartCount = document.querySelector('.cart-count');
          if (cartCount) cartCount.textContent = 'Cart (' + cart.item_count + ')';
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = originalText;
            btn.classList.remove('added');
          }, 1800);
        })
        .catch(function () {
          // fall back to a normal form submit if the AJAX call fails for any reason
          form.submit();
        });
    });
  });

  // hero video sound toggle (autoplay must stay muted for browsers to allow it;
  // this lets the visitor opt in to audio with one tap)
  var heroVideo = document.getElementById('heroVideo');
  var soundToggle = document.querySelector('[data-hero-sound-toggle]');
  if (heroVideo && soundToggle) {
    var icon = soundToggle.querySelector('[data-hero-sound-icon]');
    soundToggle.addEventListener('click', function () {
      heroVideo.muted = !heroVideo.muted;
      if (!heroVideo.muted) {
        heroVideo.play().catch(function () { /* ignore */ });
      }
      if (icon) icon.textContent = heroVideo.muted ? '🔇' : '🔊';
    });
  }

  // discount-applied popup: shows when a link like /discount/CODE?redirect=/?promo=1
  // lands the visitor back on the site with ?promo=1 in the URL. The discount itself
  // is applied by Shopify before the redirect happens - this only shows the confirmation.
  var params = new URLSearchParams(window.location.search);
  if (params.get('promo') === '1') {
    var overlay = document.getElementById('discountModalOverlay');
    if (overlay) {
      overlay.hidden = false;

      var closeModal = function () {
        overlay.hidden = true;
      };
      var closeBtn = document.getElementById('discountModalClose');
      var ctaBtn = document.getElementById('discountModalCta');
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (ctaBtn) ctaBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
    }

    // strip the ?promo=1 param so refreshing the page doesn't re-show the popup
    params.delete('promo');
    var cleanUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.history.replaceState({}, '', cleanUrl);
  }

  // mobile nav toggle
  var navToggle = document.getElementById('navToggle');
  var navLinks = document.getElementById('siteNavLinks');
  if (navToggle && navLinks) {
    var closeNav = function () {
      navLinks.classList.remove('open');
      navToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    var openNav = function () {
      navLinks.classList.add('open');
      navToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    navToggle.addEventListener('click', function () {
      if (navLinks.classList.contains('open')) closeNav();
      else openNav();
    });
    navLinks.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeNav);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });
    document.addEventListener('click', function (e) {
      if (navLinks.classList.contains('open') &&
          !navLinks.contains(e.target) &&
          !navToggle.contains(e.target)) {
        closeNav();
      }
    });
  }

  // product page: swatch-style variant picker (mirrors the collection page swatches)
  var pdpSwatchWrap = document.querySelector('[data-pdp-swatches]');
  if (pdpSwatchWrap) {
    var pdpSwatches = pdpSwatchWrap.querySelectorAll('[data-variant-swatch]');
    var pdpVariantIdInput = document.querySelector('[data-pdp-variant-id]');
    var pdpPriceEl = document.querySelector('[data-variant-price]');
    var pdpAddBtn = document.querySelector('[data-pdp-add-btn]');
    var pdpMainImage = document.querySelector('[data-pdp-main-image]');

    pdpSwatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        pdpSwatches.forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');

        if (pdpVariantIdInput && swatch.dataset.variantId) {
          pdpVariantIdInput.value = swatch.dataset.variantId;
        }
        if (pdpPriceEl && swatch.dataset.price) {
          pdpPriceEl.childNodes[0].nodeValue = swatch.dataset.price + ' ';
        }
        if (pdpMainImage && swatch.dataset.bigImage) {
          pdpMainImage.src = swatch.dataset.bigImage;
        }
        if (pdpAddBtn) {
          var soldOut = swatch.dataset.soldOut === 'true';
          pdpAddBtn.disabled = soldOut;
          pdpAddBtn.textContent = soldOut ? 'Currently unavailable' : 'Add to reserve';
        }
      });
    });
  }
});
